"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const index_1 = require("../constants/index");
const fieldTypes_1 = require("../form/fieldTypes");
/**
 * Maps through fields array and passes appropriate props to a field component.
 * The field component is created dynamically based on each field's 'type' property.
 */
function FieldList({ fields, customRows, customInlineRows }) {
    const fieldMap = customRows
        ? Object.assign(Object.assign({}, fieldTypes_1.fieldTypes), customRows) : fieldTypes_1.fieldTypes;
    return (react_1.default.createElement("div", null, fields.map((field) => {
        const { path, type, label, isRequired, width, breakpoints, isVisible } = field, rest = __rest(field, ["path", "type", "label", "isRequired", "width", "breakpoints", "isVisible"]);
        const Field = fieldMap[type];
        return (react_1.default.createElement("div", { key: `form-field-${label}-${path}-hidden:${!isVisible}` }, type === index_1.FIELD_TYPE_NAMES.INLINE ? (react_1.default.createElement(Field, Object.assign({ customInlineRows: customInlineRows, path: path, width: width, label: label, isRequired: isRequired, breakpoints: breakpoints, isVisible: isVisible }, rest))) : (react_1.default.createElement(Field, Object.assign({ path: path, width: width, label: label, isRequired: isRequired, breakpoints: breakpoints, isVisible: isVisible }, rest)))));
    })));
}
exports.default = FieldList;
//# sourceMappingURL=field-list.js.map